import { Badge, type BadgeTone } from "@generalapplications/ui";

/** Where a piece of content is in its editorial life, short of published. */
export type EditorialStatus = "idea" | "draft" | "ready";

const treatment: Record<EditorialStatus, { label: string; tone: BadgeTone }> = {
  idea: { label: "Idea", tone: "info" },
  draft: { label: "Draft", tone: "warning" },
  ready: { label: "Ready", tone: "success" },
};

export type StatusBadgeProps = {
  status: EditorialStatus;
  /** A hover note: what the state means for this page. */
  title?: string;
};

// The one lifecycle chip for articles and services alike: a reader who has
// learned what amber means on /blog should not have to relearn it on
// /services. Only ever rendered in dev: unpublished content is filtered out
// of production before it reaches a component that could show this.
export function StatusBadge({ status, title }: StatusBadgeProps) {
  const { label, tone } = treatment[status];
  return (
    <Badge tone={tone} size="sm" title={title}>
      {label}
    </Badge>
  );
}
